import * as stylex from "@stylexjs/stylex";
import { SocialMediaBluesky16 } from "icons/SocialMediaBluesky";
import { SocialMediaFacebook16 } from "icons/SocialMediaFacebook";
import { SocialMediaInstagram16 } from "icons/SocialMediaInstagram";
import { SocialMediaLinkedin16 } from "icons/SocialMediaLinkedin";
import { SocialMediaTwitter16 } from "icons/SocialMediaTwitter";
import { SocialMediaWordpress16 } from "icons/SocialMediaWordpress";
import { SocialMediaYoutube16 } from "icons/SocialMediaYoutube";
import Link from "next/link";
import { defineMessage, FormattedMessage, useIntl } from "react-intl";
import { useRTL } from "../hooks";
import { breakpoints, colors } from "../materials/consts.stylex";
import { gridCenteredMaxWidthAreas, layout } from "../materials/layout.stylex";
import { typography } from "../materials/typography.stylex";
const combinedUnescoGemLogo = new URL("../assets/combined_unesco_gem_white_eng.svg", import.meta.url).href;
const styles = {
    root: {
        kWkggS: "xdutcdc",
        kMwMTN: "x1awj2ng",
        kAzted: "x65nank x1fq4fo7",
        kLKAdn: "x9orja2 xlxyvcp",
        kGO01o: "x1gan7if x1yioc88",
        kE3dHu: "xnm25rq x1b644cj",
        kpe85a: "xyfqnmn x11wpv5z",
        $$css: true
    },
    footerLinks: {
        kJuA4N: "x1890mhu",
        k1xSpc: "x1lliihq xjmiiu8",
        kXwgrk: "xdt5ytf xfiabkx",
        kmVPX3: "xl1j9gz",
        kGNEyG: "x1cy8zhl xc23nkm",
        kGuDYH: "xx6mr1u xzap55d",
        k63SB2: "x117nqv4 xpg21gc",
        $$css: true
    }
};
export function Footer() {
    const intl = useIntl();
    const isRTL = useRTL();
    const linkProps = {
        className: "x1lliihq x1awj2ng x1hl2dhg x5z6fxw"
    };
    const spacedLinkProps = {
        0: {
            className: "x1lliihq x1awj2ng x1hl2dhg x5z6fxw x1oqrxb4"
        },
        1: {
            className: "x1lliihq x1awj2ng x1hl2dhg x5z6fxw x1uhho1l xyfqnmn"
        }
    }[!!isRTL << 0];
    const iconProps = {
        className: "xcdlrvm x1xibbik x1l36t39 x106kvsa"
    };
    const footerLinkSpacingProps = {
        0: {
            className: "x1awj2ng x1hl2dhg x5z6fxw xj3b58b x1cnd19i xtlvy1s xuc0mqo x1lliihq xpnj12b x178xt8z x3p5aeo x13fuv20 xv2d6sl x1ypiaak xwp6svo x1io81qu"
        },
        1: {
            className: "x1awj2ng x1hl2dhg x5z6fxw xj3b58b x1yf7rl7 x1jxhkki xtlvy1s xuc0mqo x1lliihq xpnj12b x178xt8z x3p5aeo x13fuv20 xv2d6sl x1ypiaak xwp6svo x1io81qu"
        }
    }[!!isRTL << 0];
    return <footer {...stylex.props(layout.gridCenteredMaxWidth, styles.root)} data-skip-search>
      <div className="x1yedbjw xrvj5dj xh8yej3 x1km1t8p x1rn6klv x1m70y6f xnut0ij">
        <div className="x1myjwxo x78zum5 xlqzeqv x14p003w x6s0dn4 xo5v014">
          <Link href="/">
            <img src={combinedUnescoGemLogo} alt="UNESCO GEM Logo" width={133}/>
          </Link>
        </div>
        <div {...stylex.props(typography.footer, styles.footerLinks)}>
          <a {...linkProps} href={intl.formatMessage(defineMessage({
        id: "url.unesco-home",
        defaultMessage: "https://en.unesco.org/"
    }))}>
            <FormattedMessage id="UNESCO Home" defaultMessage="UNESCO Home"/>
          </a>
          <a {...footerLinkSpacingProps} href={intl.formatMessage(defineMessage({
        id: "url.gem-report-home",
        defaultMessage: "https://www.unesco.org/gem-report/en"
    }))}>
            <FormattedMessage id="GEM Report Home" defaultMessage="GEM Report Home"/>
          </a>
          <Link href="/terms" {...footerLinkSpacingProps}>
            <FormattedMessage id="Terms and Conditions" defaultMessage="Terms and Conditions"/>
          </Link>
        </div>

        <div className="x18m8s3e x78zum5 x6s0dn4 xj1urod xuc0mqo x1qughib xuh2yae">
          <a {...linkProps} href="https://www.instagram.com/gemreport/">
            <SocialMediaInstagram16 {...iconProps}/>
          </a>
          <a {...spacedLinkProps} href="https://www.facebook.com/gemreportunesco">
            <SocialMediaFacebook16 {...iconProps}/>
          </a>
          <a {...spacedLinkProps} href="https://twitter.com/GEMReport">
            <SocialMediaTwitter16 {...iconProps}/>
          </a>
          <a {...spacedLinkProps} href="https://bsky.app/profile/gemreport.bsky.social">
            <SocialMediaBluesky16 {...iconProps}/>
          </a>
          <a {...spacedLinkProps} href="https://www.youtube.com/@GEMReportUNESCO">
            <SocialMediaYoutube16 {...iconProps}/>
          </a>
          <a {...spacedLinkProps} href="https://www.linkedin.com/company/gemreport-unesco">
            <SocialMediaLinkedin16 {...iconProps}/>
          </a>
          <a {...spacedLinkProps} href="https://gemreportunesco.wordpress.com/">
            <SocialMediaWordpress16 {...iconProps}/>
          </a>
        </div>
      </div>
    </footer>;
}
